module.exports = __webpack_public_path__ + "img/exam_new.37db51c7.png";